// Display helpers for transaction templates (shared by the Templates view and
// the template detail page).

export const sideLabel = (side) => (side === 'LISTING' ? 'Listing' : 'Buying');

export const countTemplate = (template) => ({
  folderCount: template?.folders?.length || 0,
  documentCount: template?.items?.length || 0,
  partyCount: template?.parties?.length || 0,
});

const PARTY_ROLE_LABELS = {
  SELLER: 'Seller',
  BUYER: 'Buyer',
  TRANSACTION_COORDINATOR: 'Transaction Coordinator',
  ESCROW_OFFICER: 'Escrow Officer',
  TITLE_OFFICER: 'Title Company',
  LENDER: 'Lender',
  LOAN_OFFICER: 'Loan Officer',
  INSPECTOR: 'Home Inspector',
  APPRAISER: 'Appraiser',
  ATTORNEY: 'Attorney',
  INSURANCE_AGENT: 'Insurance Agent',
  HOME_WARRANTY: 'Home Warranty',
  PHOTOGRAPHER: 'Photographer',
  STAGER: 'Stager',
};

export const partyRoleLabel = (role) =>
  PARTY_ROLE_LABELS[role] || (role || '').toLowerCase().replace(/_/g, ' ').replace(/^\w/, (c) => c.toUpperCase());

const SALE_TYPE_LABELS = { STANDARD: 'Standard', PROBATE: 'Probate', REO: 'REO', TRUST: 'Trust' };

// "Probate, REO or Trust"
const joinWithOr = (words) =>
  words.length > 1 ? `${words.slice(0, -1).join(', ')} or ${words[words.length - 1]}` : words[0];

/** Plain-language reasons an item is conditional, e.g. ["Required for homes built before 1978"]. */
export const conditionLabels = (condition) => {
  if (!condition) return [];
  const labels = [];
  if (condition.yearBuiltBefore) labels.push(`Required for homes built before ${condition.yearBuiltBefore}`);
  if (condition.hoa === true) labels.push('Required when the property is part of an HOA');
  if (condition.hoa === false) labels.push('Required when the property has no HOA');
  if (condition.excludeSaleTypes?.length) {
    labels.push(`Not required for ${joinWithOr(condition.excludeSaleTypes.map((s) => SALE_TYPE_LABELS[s] || s))} sales`);
  }
  return labels;
};
